import { useEffect, useState } from 'react';

import type {
  AnnouncementListFetcherParams,
  UseAnnouncementListFetcherParams,
} from './types';

export const useAnnouncementListFetcherParams: UseAnnouncementListFetcherParams =
  ({
    announcementType,
    currentInputKeyword,
    currentAnnouncementDateRange,
    announcementStatus,
    currentPage,
    currentDataIndex,
    currentOrder,
  }) => {
    const [keywordForSearch, setKeywordForSearch] = useState('');
    const [announcementDateRange, setAnnouncementDateRange] = useState<
      [string, string] | null
    >(null);

    useEffect(() => {
      if (currentAnnouncementDateRange.length === 0) {
        setAnnouncementDateRange(null);
      }

      if (currentAnnouncementDateRange[0] && currentAnnouncementDateRange[1]) {
        const startMoment = currentAnnouncementDateRange[0];
        const endMoment = currentAnnouncementDateRange[1];
        setAnnouncementDateRange([
          startMoment.format('YYYY-MM-DD'),
          endMoment.format('YYYY-MM-DD'),
        ]);
      }
    }, [currentAnnouncementDateRange]);

    useEffect(() => {
      const delayKeywordSearchTimeout = setTimeout(() => {
        setKeywordForSearch(currentInputKeyword);
      }, 1000);

      return () => {
        clearTimeout(delayKeywordSearchTimeout);
      };
    }, [currentInputKeyword]);

    let params: AnnouncementListFetcherParams = {
      limit: 10,
      skip: (currentPage - 1) * 10,
      sortDataIndex: currentDataIndex,
      sortOrder: currentOrder,
    };

    Object.entries({
      type: announcementType,
      announcementTime: announcementDateRange,
      endTime: announcementStatus,
      keyword: keywordForSearch,
    }).forEach(([key, value]) => {
      if (value) {
        params = {
          ...params,
          [key]: value,
        };
      }
    });

    return params;
  };
